import FastMarquee from "react-fast-marquee";

const ITEMS = [
  "the first forty days",
  "rest is medicine",
  "warm food, warm hands",
  "mother the mother",
  "slow is the way",
  "the village, rebuilt",
];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-espresso/10 bg-cream py-8" data-testid="editorial-marquee">
      <FastMarquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-serif text-3xl font-light italic text-espresso/80 lg:text-4xl">
              {item}
            </span>
            <span className="mx-10 inline-block h-2 w-2 rotate-45 bg-sienna" />
          </span>
        ))}
      </FastMarquee>
    </div>
  );
}
